import {BasePanelPage} from "../../panels/BasePanelPage";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {InlineUserDashboardPanelStyle} from "./InlineUserDashboardPanelStyle";
import {subscribeFlowState} from "../../../inline-subscription/SubscribeFlowState";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {apiChangeSubscription, SubscriptionApplyPolicy} from "../../../../../client/state/SubscriptionStore";
import {Messages} from "../../../../Messages";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {LabeledCheckbox} from "../../../../ui/Checkbox";
import {MerchantCheckbox} from "../../../../widget/ui/MerchantCheckbox";
import {subscribePlanController} from "../../../inline-subscription/SubscribePlanController";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {addressController} from "../../../inline-subscription/AddressController";
import {MerchantButton} from "../../../../common/MerchantButton";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {LoadingSpinner} from "../../../../ui/LoadingSpinner";
import {PaywallToast} from "../../../PaywallToast";
import {INLINE_USER_DASHBOARD_URLS} from "../../../PaywallConstants";


export async function updateSubscription(subscriptionDetails) {
    subscriptionDetails = {
        subscriptionId: iFrameUserDataService.getActiveSubscription().id,
        ...subscriptionDetails,
    };
    LoadingSpinner.show();
    let subscription = null;
    try {
        subscription = await apiChangeSubscription(subscriptionDetails);
    } catch (error) {
        PaywallToast.showError(error.message);
    } finally {
        LoadingSpinner.hide();
    }

    if (!subscription || !subscription.isActive()) {
        console.warn("Subscribe error: ", Messages.subscribeFailed);
        return;
    }
    Router.changeURL(INLINE_USER_DASHBOARD_URLS.subscriptionChangeSuccess);
}

export class InlineUserDashboardSubscriptionChangeConfirmPanelStyle extends InlineUserDashboardPanelStyle {
    @styleRule
    checkbox = {
        color: "inherit",
        fontSize: "inherit",
        marginBottom: 8,
    };

    @styleRule
    lineSeparator = {
        width: "100%",
        borderBottom: "1px solid " + this.themeProps.MERCHANT_FRAME_HEADER_BORDER_COLOR,
    };

    @styleRule
    reviewItemTitle = {
        textTransform: "uppercase",
        marginBottom: 8,
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };
}

@registerStyle(InlineUserDashboardSubscriptionChangeConfirmPanelStyle)
export class InlineUserDashboardSubscriptionChangeConfirmPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.reviewChange,
        }
    }

    render() {
        const {selectedOffer, discountCode, applyPolicy} = subscribePlanController;
        const instantPayInfo = subscribeFlowState.getDiscountInfoOnInstantChangePolicy(selectedOffer);
        const nextCyclePayInfo = subscribeFlowState.getDiscountInfo(selectedOffer);
        const activeSubscription = iFrameUserDataService.getActiveSubscription();
        const selectedCoverage = selectedOffer == null ? activeSubscription.coverage : selectedOffer.coverage;
        const selectedBillingPlan = selectedOffer == null ? activeSubscription.billingPlan : selectedOffer.billingPlan;

        const {styleSheet} = this;
        const paidUntil = activeSubscription.getPaidUntil();
        const nextBillingDate = activeSubscription.getNextBillingDate();

        const paymentInfoMessageArgs = [
            selectedBillingPlan.formatPrice(nextCyclePayInfo.finalPrice),
            selectedBillingPlan.getCycleDuration(true),
            nextBillingDate.format("MMM DD, YYYY")
        ];
        const updatePaymentInfo = applyPolicy === SubscriptionApplyPolicy.NEXT_BILLING_CYCLE ? [
                Messages.updateAtEndCyclePaymentInfo(...paymentInfoMessageArgs),
                subscribeFlowState.userHasEquivalentSubscriptionToSelected() ? "" : Messages.updateAtEndCycleChangeOffer].join("")
            : Messages.updateInstantlyPaymentInfo(
                selectedBillingPlan.formatPrice(instantPayInfo.finalPrice),
                ...paymentInfoMessageArgs);

        let checkboxElement = null;
        if (instantPayInfo.finalPrice !== nextCyclePayInfo.finalPrice) {
            checkboxElement = <LabeledCheckbox className={styleSheet.checkbox}
                                               onChange={enabled => {
                                                   subscribePlanController.applyPolicy = enabled ? SubscriptionApplyPolicy.NEXT_BILLING_CYCLE :
                                                       SubscriptionApplyPolicy.INSTANTLY;
                                                   this.redraw();
                                               }}
                                               CheckboxClass={MerchantCheckbox} initialValue={applyPolicy === SubscriptionApplyPolicy.NEXT_BILLING_CYCLE}
                                               label={Messages.updateAtEndCycleCheckbox(paidUntil.format("MMM DD, YYYY"))}/>;
        }

        return [
            !subscribeFlowState.userHasEquivalentSubscriptionToSelected() ?
                <div>
                    <div className={styleSheet.reviewItemTitle}>{Messages.subscriptionPlan}</div>
                    <MessageElement message={Messages.updateSubscriptionPlanDescription(selectedCoverage.name, selectedBillingPlan.formatPrice(nextCyclePayInfo.finalPrice))}/>
                    <div className={styleSheet.lineSeparator}/>
                </div> : null,
            selectedCoverage.requiresAddress || (selectedOffer != null && selectedOffer.shouldCollectAddress()) ?
                <div>
                    <div className={styleSheet.reviewItemTitle}>{Messages.address}</div>
                    <MessageElement message={Messages.updateSubscriptionPlanAddress(addressController.selectedAddress.toString())}/>
                    <div className={styleSheet.lineSeparator}/>
                </div> : null,
            !subscribeFlowState.userHasEquivalentSubscriptionToSelected() ?
                <div>
                    <div className={styleSheet.reviewItemTitle}>{Messages.payment}</div>
                    {checkboxElement}
                    <MessageElement message={updatePaymentInfo}/>
                </div> : null,
            <MerchantButton label={Messages.changeSubscription} className={styleSheet.button}
                            onClick={() => updateSubscription({
                                applyPolicy,
                                recurringOfferId: selectedOffer == null ? null : selectedOffer.id,
                                userAddressId: addressController.selectedAddress.id,
                                discountCode: nextCyclePayInfo.discountValue ? discountCode : null,
                            })}/>,
            <div className={styleSheet.center}>
                <div className={styleSheet.secondaryButton} onClick={() => Router.back()}>
                    {Messages.back}
                </div>
            </div>
        ];
    }
}
